import { useQuery } from '@apollo/react-hooks';
import { get } from 'lodash';
import getCourses from '../api/getCourses.query';

export default (vendorUuid) => {
    const { data, loading, error } = useQuery(getCourses, {
        variables: { vendorUuid },
    });

    if (error) {
        console.log('Error', error);
    }

    const courses = get(data, 'getFilteredProducts.data', []);

    return {
        loading,
        data: courses,
    };
};
